'use client'

import React, { useEffect } from 'react'
import { ArtistTalk } from './ArtistTalk'
import { FooterDescription } from './FooterDescription'
import { PurchaseButtonSection } from './PurchaseButtonSection'
import { homeActionLog } from '@/modules/action-log/home'
import { LoopyHeader } from '@/components/ui/header/LoopyHeader'
import { memberService } from '@/modules/member'
import { useSalePeriod } from '@/hooks/sale/useSalePeriod'

const LOOPIY_SALE_START_AT = '2025-10-20 12:00:00'
const LOOPIY_SALE_END_AT = '2025-11-02 23:59:59'
export const HomePage = () => {
  useEffect(() => {
    homeActionLog.inital()
    memberService.mainInit()
  }, [])
  const { isSaleEnded } = useSalePeriod({
    startAt: LOOPIY_SALE_START_AT,
    endAt: LOOPIY_SALE_END_AT,
  })

  return (
    <div className="flex flex-col relative bg-[#4D4B66] min-h-[100%] max-w-[100%]">
      <LoopyHeader />
      <div className="bg-[#FF6DB3] h-[40px] flex items-center justify-center gap-[8px]">
        {isSaleEnded ? (
          <p className="text-white text-center text-body3_strong">[ 판매가 종료되었습니다 ]</p>
        ) : (
          <>
            <p className="text-white text-center text-body3_strong">한정 판매 기간</p>
            <p className="text-white/90 text-center text-[14px] font-normal leading-[16px]">
              10/20{'(월)'} 12:00 ~ 11/2{'(일)'} 23:59
            </p>
          </>
        )}
      </div>
      <div>
        <div
          className="bg-cover bg-no-repeat bg-center bg-gray-300 h-[600px] flex flex-col relative"
          style={{ backgroundImage: 'url(/img/home/loopy/background.png)' }}
        >
          <div className="w-[100%] flex justify-center items-center pt-[16px]">
            <ArtistTalk />
          </div>
          {isSaleEnded ? null : <PurchaseButtonSection />}
        </div>
        <FooterDescription />
      </div>
    </div>
  )
}
